import { render, staticRenderFns } from "./parkingSpaceCarDetail.vue?vue&type=template&id=19cb2bca&scoped=true"
import script from "./parkingSpaceCarDetail.vue?vue&type=script&lang=js"
export * from "./parkingSpaceCarDetail.vue?vue&type=script&lang=js"
import style0 from "./parkingSpaceCarDetail.vue?vue&type=style&index=0&id=19cb2bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb2bca",
  null
  
)

export default component.exports